import Vue from 'vue';
import formatCurrency from '~/lib/formatCurrency';

export default Vue.filter('formatCurrency', (value, currency, locale, decimalPlaces = 2, minDecimalPlaces = null) => formatCurrency(value, currency, locale, decimalPlaces, minDecimalPlaces));
